import { userService } from './userService';

const API_BASE_URL = (() => {
  const fromEnv = process.env.REACT_APP_API_URL;
  if (fromEnv && fromEnv.trim().length > 0) return fromEnv;
  
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname || '';
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    const isDevSite = hostname.includes('saas-application-dev.s3-website.eu-north-1.amazonaws.com');
    
    if (isLocalhost || isDevSite) {
      return 'https://9vnb05of2j.execute-api.eu-north-1.amazonaws.com/development';
    }
  }
  
  return 'https://5z9vmw0tg6.execute-api.eu-north-1.amazonaws.com/production';
})();

export interface TokenExchangeResponse {
  access_token: string;
  scope: string;
  expires_in?: number;
  associated_user_scope?: string;
  associated_user?: {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    locale: string;
    email_verified: boolean;
    account_owner: boolean;
    collaborator: boolean;
  };
}

export const shopifyAuthService = {
  /**
   * Exchange Shopify session token for access token
   * Uses the hybrid OAuth callback endpoint that supports both legacy and modern flows
   */
  async exchangeToken(sessionToken: string, shop: string): Promise<TokenExchangeResponse> {
    try {
      const jwtToken = await userService.getAuthToken();
      
      // Use the same OAuth callback endpoint - it auto-detects POST with session_token
      const response = await fetch(`${API_BASE_URL}/shopify/oauth-callback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${jwtToken}`,
        },
        body: JSON.stringify({
          session_token: sessionToken,
          shop: shop,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Token exchange failed: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('[Shopify Auth] Token exchange successful');
      
      return data;
    } catch (error) {
      console.error('[Shopify Auth] Token exchange error:', error);
      throw error;
    }
  },
};

